export const diff = (a: string[], b: string[]) => {
    return {
        remove: a.filter((x) => !b.includes(x)),
        add: b.filter((x) => !a.includes(x)),
    };
};

interface getLegendUrlProps {
    wxtilesEndpoint: string;
    urlTemplate: string;
}
export const getLegendUrl = ({ wxtilesEndpoint, urlTemplate }: getLegendUrlProps) => {
    return wxtilesEndpoint + '/v1/' + urlTemplate.split('<size>').join('small').split('<orientation>').join('horizontal');
};
